/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CouponCode,
  Courier,
  CourierBill,
  CourierPackage,
  CourierSettings,
  CourierUser,
  Invoice,
  MailOption,
  Manifest,
  NewCouponCode,
  NewCourierBill,
  NewCourierPackage,
  NewManifest,
  NewPushSubscription,
  NewRewardsAccount,
  NewStoreLocation,
  Plan,
  PushSubscription,
  RewardSettings,
  RewardsAccount,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  StoreLocation,
  ThemeSetting,
} from '../models/index';
import {
    CouponCodeFromJSON,
    CouponCodeToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierBillFromJSON,
    CourierBillToJSON,
    CourierPackageFromJSON,
    CourierPackageToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    CourierUserFromJSON,
    CourierUserToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    ManifestFromJSON,
    ManifestToJSON,
    NewCouponCodeFromJSON,
    NewCouponCodeToJSON,
    NewCourierBillFromJSON,
    NewCourierBillToJSON,
    NewCourierPackageFromJSON,
    NewCourierPackageToJSON,
    NewManifestFromJSON,
    NewManifestToJSON,
    NewPushSubscriptionFromJSON,
    NewPushSubscriptionToJSON,
    NewRewardsAccountFromJSON,
    NewRewardsAccountToJSON,
    NewStoreLocationFromJSON,
    NewStoreLocationToJSON,
    PlanFromJSON,
    PlanToJSON,
    PushSubscriptionFromJSON,
    PushSubscriptionToJSON,
    RewardSettingsFromJSON,
    RewardSettingsToJSON,
    RewardsAccountFromJSON,
    RewardsAccountToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    StoreLocationFromJSON,
    StoreLocationToJSON,
    ThemeSettingFromJSON,
    ThemeSettingToJSON,
} from '../models/index';

export interface ManifestCountRequest {
    where?: string;
}

export interface ManifestCreateRequest {
    data?: NewManifest;
}

export interface ManifestCreateChangeStreamGetManifestsChangeStreamRequest {
    options?: string;
}

export interface ManifestCreateChangeStreamPostManifestsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface ManifestDeleteByIdRequest {
    id: string;
}

export interface ManifestExistsGetManifestsidExistsRequest {
    id: string;
}

export interface ManifestExistsHeadManifestsidRequest {
    id: string;
}

export interface ManifestExportManifestDataRequest {
    manifestId: number;
}

export interface ManifestFindRequest {
    filter?: string;
}

export interface ManifestFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ManifestFindOneRequest {
    filter?: string;
}

export interface ManifestGenerateManifestRequest {
    manifestRequest: {
        awbReference?: string;
        courierId: number;
        createdBy?: string;
        endDate?: string;
        id?: number;
        masterAwb?: string;
        startDate?: string;
        status: 'Pre Alert' | 'In Transit' | 'Ready' | 'Delivered' | 'none'
    };
}

export interface ManifestGenerateSubCourierManifestsRequest {
    manifestId: number;
}

export interface ManifestNotifySubCouriersRequest {
    manifestId: number;
    status: string;
}

export interface ManifestRegenerateManifestRequest {
    manifestId: number;
}

export interface ManifestNotifySubCourierNotifiedDetail {
    courierId: number;
    name: string;
    packages: number;
    email?: boolean;
    whatsapp?: boolean;
}

export interface ManifestNotifySubCourierFailedDetail {
    courierId: number;
    name: string;
    reason: string;
}

export interface ManifestNotifySubCouriersResponse {
    notified: number;
    failed?: number;
    message?: string;
    details?: {
        notified: ManifestNotifySubCourierNotifiedDetail[];
        failed: ManifestNotifySubCourierFailedDetail[];
    };
}

export interface ManifestPatchOrCreateRequest {
    data?: Manifest;
}

export interface ManifestPrototypeCountCourierCouponCodesRequest {
    id: string;
    where?: string;
}

export interface ManifestPrototypeCountCourierCourierBillsRequest {
    id: string;
    where?: string;
}

export interface ManifestPrototypeCountCourierPackagesRequest {
    id: string;
    where?: string;
}

export interface ManifestPrototypeCountCourierPushSubscribersRequest {
    id: string;
    where?: string;
}

export interface ManifestPrototypeCountCourierRewardsAccountsRequest {
    id: string;
    where?: string;
}

export interface ManifestPrototypeCountCourierStoreLocationsRequest {
    id: string;
    where?: string;
}

export interface ManifestPrototypeCreateCourierCouponCodesRequest {
    id: string;
    data?: NewCouponCode;
}

export interface ManifestPrototypeCreateCourierCourierBillsRequest {
    id: string;
    data?: NewCourierBill;
}

export interface ManifestPrototypeCreateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface ManifestPrototypeCreateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface ManifestPrototypeCreateCourierPackagesRequest {
    id: string;
    data?: NewCourierPackage;
}

export interface ManifestPrototypeCreateCourierPackagesInvoiceRequest {
    id: string;
    nk: string;
    data?: Invoice;
}

export interface ManifestPrototypeCreateCourierPushSubscribersRequest {
    id: string;
    data?: NewPushSubscription;
}

export interface ManifestPrototypeCreateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface ManifestPrototypeCreateCourierRewardsAccountsRequest {
    id: string;
    data?: NewRewardsAccount;
}

export interface ManifestPrototypeCreateCourierStoreLocationsRequest {
    id: string;
    data?: NewStoreLocation;
}

export interface ManifestPrototypeCreateCourierThemeSettingRequest {
    id: string;
    data?: ThemeSetting;
}

export interface ManifestPrototypeDeleteCourierCouponCodesRequest {
    id: string;
}

export interface ManifestPrototypeDeleteCourierCourierBillsRequest {
    id: string;
}

export interface ManifestPrototypeDeleteCourierPackagesRequest {
    id: string;
}

export interface ManifestPrototypeDeleteCourierPushSubscribersRequest {
    id: string;
}

export interface ManifestPrototypeDeleteCourierRewardsAccountsRequest {
    id: string;
}

export interface ManifestPrototypeDeleteCourierStoreLocationsRequest {
    id: string;
}

export interface ManifestPrototypeDestroyByIdCourierCouponCodesRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeDestroyByIdCourierCourierBillsRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeDestroyByIdCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeDestroyByIdCourierPushSubscribersRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeDestroyByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeDestroyByIdCourierStoreLocationsRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeDestroyCourierCourierSettingRequest {
    id: string;
}

export interface ManifestPrototypeDestroyCourierMailOptionRequest {
    id: string;
}

export interface ManifestPrototypeDestroyCourierPackagesInvoiceRequest {
    id: string;
    nk: string;
}

export interface ManifestPrototypeDestroyCourierRewardSettingRequest {
    id: string;
}

export interface ManifestPrototypeDestroyCourierThemeSettingRequest {
    id: string;
}

export interface ManifestPrototypeFindByIdCourierCouponCodesRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeFindByIdCourierCourierBillsRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeFindByIdCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeFindByIdCourierPushSubscribersRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeFindByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeFindByIdCourierStoreLocationsRequest {
    id: string;
    fk: string;
}

export interface ManifestPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierCouponCodesRequest {
    id: string;
    filter?: string;
}

export interface ManifestPrototypeGetCourierCourierBillsRequest {
    id: string;
    filter?: string;
}

export interface ManifestPrototypeGetCourierCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierPackagesRequest {
    id: string;
    filter?: string;
}

export interface ManifestPrototypeGetCourierPackagesCourierRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierPackagesInvoiceRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierPackagesOwnerRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierPackagesStoreLocationRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierPlanRequest {
    id: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierPushSubscribersRequest {
    id: string;
    filter?: string;
}

export interface ManifestPrototypeGetCourierRewardSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface ManifestPrototypeGetCourierRewardsAccountsRequest {
    id: string;
    filter?: string;
}

export interface ManifestPrototypeGetCourierStoreLocationsRequest {
    id: string;
    filter?: string;
}

export interface ManifestPrototypeGetCourierThemeSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface ManifestPrototypePatchAttributesRequest {
    id: string;
    data?: Manifest;
}

export interface ManifestPrototypeUpdateByIdCourierCouponCodesRequest {
    id: string;
    fk: string;
    data?: CouponCode;
}

export interface ManifestPrototypeUpdateByIdCourierCourierBillsRequest {
    id: string;
    fk: string;
    data?: CourierBill;
}

export interface ManifestPrototypeUpdateByIdCourierPackagesRequest {
    id: string;
    fk: string;
    data?: CourierPackage;
}

export interface ManifestPrototypeUpdateByIdCourierPushSubscribersRequest {
    id: string;
    fk: string;
    data?: PushSubscription;
}

export interface ManifestPrototypeUpdateByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
    data?: RewardsAccount;
}

export interface ManifestPrototypeUpdateByIdCourierStoreLocationsRequest {
    id: string;
    fk: string;
    data?: StoreLocation;
}

export interface ManifestPrototypeUpdateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface ManifestPrototypeUpdateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface ManifestPrototypeUpdateCourierPackagesInvoiceRequest {
    id: string;
    nk: string;
    data?: Invoice;
}

export interface ManifestPrototypeUpdateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface ManifestPrototypeUpdateCourierThemeSettingRequest {
    id: string;
    data?: ThemeSetting;
}

export interface ManifestReplaceByIdPostManifestsidReplaceRequest {
    id: string;
    data?: Manifest;
}

export interface ManifestReplaceByIdPutManifestsidRequest {
    id: string;
    data?: Manifest;
}

export interface ManifestReplaceOrCreatePostManifestsReplaceOrCreateRequest {
    data?: Manifest;
}

export interface ManifestReplaceOrCreatePutManifestsRequest {
    data?: Manifest;
}

export interface ManifestUpdateAllRequest {
    where?: string;
    data?: Manifest;
}

export interface ManifestUpsertWithWhereRequest {
    where?: string;
    data?: Manifest;
}

export interface ManifestGetOrphanPackagesRequest {
    courierId: number;
    filters?: {
        dateFrom?: string;
        dateTo?: string;
        limit?: number;
        skip?: number;
    };
}

export interface ManifestAssignPackagesToManifestRequest {
    manifestId: number;
    packageIds: number[];
}

export interface ManifestCloseManifestRequest {
    manifestId: number;
}

export interface ManifestReopenManifestRequest {
    manifestId: number;
}

export interface ManifestGetActiveManifestRequest {
    courierId: number;
}

export interface ManifestReassignPackagesRequest {
    data: {
        packageIds: number[];
        targetManifestId: number;
    };
}

/**
 *
 */
export class ManifestApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async manifestCountRaw(requestParameters: ManifestCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async manifestCount(requestParameters: ManifestCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async manifestCreateRaw(requestParameters: ManifestCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async manifestCreate(requestParameters: ManifestCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async manifestCreateChangeStreamGetManifestsChangeStreamRaw(requestParameters: ManifestCreateChangeStreamGetManifestsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async manifestCreateChangeStreamGetManifestsChangeStream(requestParameters: ManifestCreateChangeStreamGetManifestsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.manifestCreateChangeStreamGetManifestsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async manifestCreateChangeStreamPostManifestsChangeStreamRaw(requestParameters: ManifestCreateChangeStreamPostManifestsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async manifestCreateChangeStreamPostManifestsChangeStream(requestParameters: ManifestCreateChangeStreamPostManifestsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.manifestCreateChangeStreamPostManifestsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async manifestDeleteByIdRaw(requestParameters: ManifestDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async manifestDeleteById(requestParameters: ManifestDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.manifestDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async manifestExistsGetManifestsidExistsRaw(requestParameters: ManifestExistsGetManifestsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestExistsGetManifestsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async manifestExistsGetManifestsidExists(requestParameters: ManifestExistsGetManifestsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.manifestExistsGetManifestsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async manifestExistsHeadManifestsidRaw(requestParameters: ManifestExistsHeadManifestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestExistsHeadManifestsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async manifestExistsHeadManifestsid(requestParameters: ManifestExistsHeadManifestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.manifestExistsHeadManifestsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async manifestExportManifestDataRaw(requestParameters: ManifestExportManifestDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError(
                'manifestId',
                'Required parameter "manifestId" was null or undefined when calling manifestExportManifestData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/exportManifestData/{manifestId}`.replace(`{${"manifestId"}}`, encodeURIComponent(String(requestParameters['manifestId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async manifestExportManifestData(requestParameters: ManifestExportManifestDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestExportManifestDataRaw(requestParameters, initOverrides);
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async manifestFindRaw(requestParameters: ManifestFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Manifest>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ManifestFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async manifestFind(requestParameters: ManifestFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Manifest>> {
        const response = await this.manifestFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async manifestFindByIdRaw(requestParameters: ManifestFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async manifestFindById(requestParameters: ManifestFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async manifestFindOneRaw(requestParameters: ManifestFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async manifestFindOne(requestParameters: ManifestFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async manifestGenerateManifestRaw(requestParameters: ManifestGenerateManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['manifestRequest'] == null) {
            throw new runtime.RequiredError(
                'manifestRequest',
                'Required parameter "manifestRequest" was null or undefined when calling manifestGenerateManifest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/generateManifest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['manifestRequest'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async manifestGenerateManifest(requestParameters: ManifestGenerateManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.manifestGenerateManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate sub-courier manifests for a warehouse manifest (on-demand).
     */
    async manifestGenerateSubCourierManifestsRaw(requestParameters: ManifestGenerateSubCourierManifestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError(
                'manifestId',
                'Required parameter "manifestId" was null or undefined when calling manifestGenerateSubCourierManifests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/generateSubCourierManifests/{manifestId}`.replace(`{${"manifestId"}}`, encodeURIComponent(String(requestParameters['manifestId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Generate sub-courier manifests for a warehouse manifest (on-demand).
     */
    async manifestGenerateSubCourierManifests(requestParameters: ManifestGenerateSubCourierManifestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.manifestGenerateSubCourierManifestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-add unassigned packages within the manifest's date range.
     */
    async manifestRegenerateManifestRaw(requestParameters: ManifestRegenerateManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError(
                'manifestId',
                'Required parameter "manifestId" was null or undefined when calling manifestRegenerateManifest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/regenerateManifest/{manifestId}`.replace(`{${"manifestId"}}`, encodeURIComponent(String(requestParameters['manifestId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Re-add unassigned packages within the manifest's date range.
     */
    async manifestRegenerateManifest(requestParameters: ManifestRegenerateManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.manifestRegenerateManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Notify sub-couriers about manifest status changes.
     */
    async manifestNotifySubCouriersRaw(requestParameters: ManifestNotifySubCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManifestNotifySubCouriersResponse>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError(
                'manifestId',
                'Required parameter "manifestId" was null or undefined when calling manifestNotifySubCouriers().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling manifestNotifySubCouriers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{manifestId}/notify-sub-couriers`.replace(`{${"manifestId"}}`, encodeURIComponent(String(requestParameters['manifestId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: { status: requestParameters['status'] },
        }, initOverrides);

        return new runtime.JSONApiResponse<ManifestNotifySubCouriersResponse>(response);
    }

    /**
     * Notify sub-couriers about manifest status changes.
     */
    async manifestNotifySubCouriers(requestParameters: ManifestNotifySubCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManifestNotifySubCouriersResponse> {
        const response = await this.manifestNotifySubCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async manifestPatchOrCreateRaw(requestParameters: ManifestPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async manifestPatchOrCreate(requestParameters: ManifestPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts couponCodes of Courier.
     */
    async manifestPrototypeCountCourierCouponCodesRaw(requestParameters: ManifestPrototypeCountCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCountCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts couponCodes of Courier.
     */
    async manifestPrototypeCountCourierCouponCodes(requestParameters: ManifestPrototypeCountCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestPrototypeCountCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierBills of Courier.
     */
    async manifestPrototypeCountCourierCourierBillsRaw(requestParameters: ManifestPrototypeCountCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCountCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierBills of Courier.
     */
    async manifestPrototypeCountCourierCourierBills(requestParameters: ManifestPrototypeCountCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestPrototypeCountCourierCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierPackages of Manifest.
     */
    async manifestPrototypeCountCourierPackagesRaw(requestParameters: ManifestPrototypeCountCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCountCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierPackages of Manifest.
     */
    async manifestPrototypeCountCourierPackages(requestParameters: ManifestPrototypeCountCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestPrototypeCountCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts pushSubscribers of Courier.
     */
    async manifestPrototypeCountCourierPushSubscribersRaw(requestParameters: ManifestPrototypeCountCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCountCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts pushSubscribers of Courier.
     */
    async manifestPrototypeCountCourierPushSubscribers(requestParameters: ManifestPrototypeCountCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestPrototypeCountCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async manifestPrototypeCountCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCountCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async manifestPrototypeCountCourierRewardsAccounts(requestParameters: ManifestPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestPrototypeCountCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts storeLocations of Courier.
     */
    async manifestPrototypeCountCourierStoreLocationsRaw(requestParameters: ManifestPrototypeCountCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCountCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts storeLocations of Courier.
     */
    async manifestPrototypeCountCourierStoreLocations(requestParameters: ManifestPrototypeCountCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.manifestPrototypeCountCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in couponCodes of this model.
     */
    async manifestPrototypeCreateCourierCouponCodesRaw(requestParameters: ManifestPrototypeCreateCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCouponCodeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in couponCodes of this model.
     */
    async manifestPrototypeCreateCourierCouponCodes(requestParameters: ManifestPrototypeCreateCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.manifestPrototypeCreateCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierBills of this model.
     */
    async manifestPrototypeCreateCourierCourierBillsRaw(requestParameters: ManifestPrototypeCreateCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierBillToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierBillFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierBills of this model.
     */
    async manifestPrototypeCreateCourierCourierBills(requestParameters: ManifestPrototypeCreateCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierBill> {
        const response = await this.manifestPrototypeCreateCourierCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async manifestPrototypeCreateCourierCourierSettingRaw(requestParameters: ManifestPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async manifestPrototypeCreateCourierCourierSetting(requestParameters: ManifestPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.manifestPrototypeCreateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async manifestPrototypeCreateCourierMailOptionRaw(requestParameters: ManifestPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async manifestPrototypeCreateCourierMailOption(requestParameters: ManifestPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.manifestPrototypeCreateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async manifestPrototypeCreateCourierPackagesRaw(requestParameters: ManifestPrototypeCreateCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async manifestPrototypeCreateCourierPackages(requestParameters: ManifestPrototypeCreateCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.manifestPrototypeCreateCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoice of this model.
     */
    async manifestPrototypeCreateCourierPackagesInvoiceRaw(requestParameters: ManifestPrototypeCreateCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierPackagesInvoice().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeCreateCourierPackagesInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoice of this model.
     */
    async manifestPrototypeCreateCourierPackagesInvoice(requestParameters: ManifestPrototypeCreateCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.manifestPrototypeCreateCourierPackagesInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in pushSubscribers of this model.
     */
    async manifestPrototypeCreateCourierPushSubscribersRaw(requestParameters: ManifestPrototypeCreateCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewPushSubscriptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in pushSubscribers of this model.
     */
    async manifestPrototypeCreateCourierPushSubscribers(requestParameters: ManifestPrototypeCreateCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.manifestPrototypeCreateCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async manifestPrototypeCreateCourierRewardSettingRaw(requestParameters: ManifestPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async manifestPrototypeCreateCourierRewardSetting(requestParameters: ManifestPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.manifestPrototypeCreateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async manifestPrototypeCreateCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async manifestPrototypeCreateCourierRewardsAccounts(requestParameters: ManifestPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.manifestPrototypeCreateCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in storeLocations of this model.
     */
    async manifestPrototypeCreateCourierStoreLocationsRaw(requestParameters: ManifestPrototypeCreateCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewStoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in storeLocations of this model.
     */
    async manifestPrototypeCreateCourierStoreLocations(requestParameters: ManifestPrototypeCreateCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.manifestPrototypeCreateCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in themeSetting of this model.
     */
    async manifestPrototypeCreateCourierThemeSettingRaw(requestParameters: ManifestPrototypeCreateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeCreateCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in themeSetting of this model.
     */
    async manifestPrototypeCreateCourierThemeSetting(requestParameters: ManifestPrototypeCreateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.manifestPrototypeCreateCourierThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all couponCodes of this model.
     */
    async manifestPrototypeDeleteCourierCouponCodesRaw(requestParameters: ManifestPrototypeDeleteCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDeleteCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all couponCodes of this model.
     */
    async manifestPrototypeDeleteCourierCouponCodes(requestParameters: ManifestPrototypeDeleteCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDeleteCourierCouponCodesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierBills of this model.
     */
    async manifestPrototypeDeleteCourierCourierBillsRaw(requestParameters: ManifestPrototypeDeleteCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDeleteCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierBills of this model.
     */
    async manifestPrototypeDeleteCourierCourierBills(requestParameters: ManifestPrototypeDeleteCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDeleteCourierCourierBillsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async manifestPrototypeDeleteCourierPackagesRaw(requestParameters: ManifestPrototypeDeleteCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDeleteCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async manifestPrototypeDeleteCourierPackages(requestParameters: ManifestPrototypeDeleteCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDeleteCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all pushSubscribers of this model.
     */
    async manifestPrototypeDeleteCourierPushSubscribersRaw(requestParameters: ManifestPrototypeDeleteCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDeleteCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all pushSubscribers of this model.
     */
    async manifestPrototypeDeleteCourierPushSubscribers(requestParameters: ManifestPrototypeDeleteCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDeleteCourierPushSubscribersRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async manifestPrototypeDeleteCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDeleteCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async manifestPrototypeDeleteCourierRewardsAccounts(requestParameters: ManifestPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDeleteCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all storeLocations of this model.
     */
    async manifestPrototypeDeleteCourierStoreLocationsRaw(requestParameters: ManifestPrototypeDeleteCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDeleteCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all storeLocations of this model.
     */
    async manifestPrototypeDeleteCourierStoreLocations(requestParameters: ManifestPrototypeDeleteCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDeleteCourierStoreLocationsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for couponCodes.
     */
    async manifestPrototypeDestroyByIdCourierCouponCodesRaw(requestParameters: ManifestPrototypeDestroyByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyByIdCourierCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeDestroyByIdCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for couponCodes.
     */
    async manifestPrototypeDestroyByIdCourierCouponCodes(requestParameters: ManifestPrototypeDestroyByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyByIdCourierCouponCodesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierBills.
     */
    async manifestPrototypeDestroyByIdCourierCourierBillsRaw(requestParameters: ManifestPrototypeDestroyByIdCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyByIdCourierCourierBills().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeDestroyByIdCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierBills.
     */
    async manifestPrototypeDestroyByIdCourierCourierBills(requestParameters: ManifestPrototypeDestroyByIdCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyByIdCourierCourierBillsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async manifestPrototypeDestroyByIdCourierPackagesRaw(requestParameters: ManifestPrototypeDestroyByIdCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyByIdCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeDestroyByIdCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async manifestPrototypeDestroyByIdCourierPackages(requestParameters: ManifestPrototypeDestroyByIdCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyByIdCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for pushSubscribers.
     */
    async manifestPrototypeDestroyByIdCourierPushSubscribersRaw(requestParameters: ManifestPrototypeDestroyByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyByIdCourierPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeDestroyByIdCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for pushSubscribers.
     */
    async manifestPrototypeDestroyByIdCourierPushSubscribers(requestParameters: ManifestPrototypeDestroyByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyByIdCourierPushSubscribersRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async manifestPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async manifestPrototypeDestroyByIdCourierRewardsAccounts(requestParameters: ManifestPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for storeLocations.
     */
    async manifestPrototypeDestroyByIdCourierStoreLocationsRaw(requestParameters: ManifestPrototypeDestroyByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyByIdCourierStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeDestroyByIdCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for storeLocations.
     */
    async manifestPrototypeDestroyByIdCourierStoreLocations(requestParameters: ManifestPrototypeDestroyByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyByIdCourierStoreLocationsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async manifestPrototypeDestroyCourierCourierSettingRaw(requestParameters: ManifestPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async manifestPrototypeDestroyCourierCourierSetting(requestParameters: ManifestPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyCourierCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async manifestPrototypeDestroyCourierMailOptionRaw(requestParameters: ManifestPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async manifestPrototypeDestroyCourierMailOption(requestParameters: ManifestPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyCourierMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes invoice of this model.
     */
    async manifestPrototypeDestroyCourierPackagesInvoiceRaw(requestParameters: ManifestPrototypeDestroyCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyCourierPackagesInvoice().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeDestroyCourierPackagesInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes invoice of this model.
     */
    async manifestPrototypeDestroyCourierPackagesInvoice(requestParameters: ManifestPrototypeDestroyCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyCourierPackagesInvoiceRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async manifestPrototypeDestroyCourierRewardSettingRaw(requestParameters: ManifestPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async manifestPrototypeDestroyCourierRewardSetting(requestParameters: ManifestPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyCourierRewardSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes themeSetting of this model.
     */
    async manifestPrototypeDestroyCourierThemeSettingRaw(requestParameters: ManifestPrototypeDestroyCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeDestroyCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes themeSetting of this model.
     */
    async manifestPrototypeDestroyCourierThemeSetting(requestParameters: ManifestPrototypeDestroyCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.manifestPrototypeDestroyCourierThemeSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Find a related item by id for couponCodes.
     */
    async manifestPrototypeFindByIdCourierCouponCodesRaw(requestParameters: ManifestPrototypeFindByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeFindByIdCourierCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeFindByIdCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for couponCodes.
     */
    async manifestPrototypeFindByIdCourierCouponCodes(requestParameters: ManifestPrototypeFindByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.manifestPrototypeFindByIdCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierBills.
     */
    async manifestPrototypeFindByIdCourierCourierBillsRaw(requestParameters: ManifestPrototypeFindByIdCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeFindByIdCourierCourierBills().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeFindByIdCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierBillFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierBills.
     */
    async manifestPrototypeFindByIdCourierCourierBills(requestParameters: ManifestPrototypeFindByIdCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierBill> {
        const response = await this.manifestPrototypeFindByIdCourierCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async manifestPrototypeFindByIdCourierPackagesRaw(requestParameters: ManifestPrototypeFindByIdCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeFindByIdCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeFindByIdCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async manifestPrototypeFindByIdCourierPackages(requestParameters: ManifestPrototypeFindByIdCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.manifestPrototypeFindByIdCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for pushSubscribers.
     */
    async manifestPrototypeFindByIdCourierPushSubscribersRaw(requestParameters: ManifestPrototypeFindByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeFindByIdCourierPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeFindByIdCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for pushSubscribers.
     */
    async manifestPrototypeFindByIdCourierPushSubscribers(requestParameters: ManifestPrototypeFindByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.manifestPrototypeFindByIdCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async manifestPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async manifestPrototypeFindByIdCourierRewardsAccounts(requestParameters: ManifestPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.manifestPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for storeLocations.
     */
    async manifestPrototypeFindByIdCourierStoreLocationsRaw(requestParameters: ManifestPrototypeFindByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeFindByIdCourierStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeFindByIdCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for storeLocations.
     */
    async manifestPrototypeFindByIdCourierStoreLocations(requestParameters: ManifestPrototypeFindByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.manifestPrototypeFindByIdCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async manifestPrototypeGetCourierRaw(requestParameters: ManifestPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async manifestPrototypeGetCourier(requestParameters: ManifestPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.manifestPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries couponCodes of Courier.
     */
    async manifestPrototypeGetCourierCouponCodesRaw(requestParameters: ManifestPrototypeGetCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponCode>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponCodeFromJSON));
    }

    /**
     * Queries couponCodes of Courier.
     */
    async manifestPrototypeGetCourierCouponCodes(requestParameters: ManifestPrototypeGetCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponCode>> {
        const response = await this.manifestPrototypeGetCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierBills of Courier.
     */
    async manifestPrototypeGetCourierCourierBillsRaw(requestParameters: ManifestPrototypeGetCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierBill>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierBillFromJSON));
    }

    /**
     * Queries courierBills of Courier.
     */
    async manifestPrototypeGetCourierCourierBills(requestParameters: ManifestPrototypeGetCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierBill>> {
        const response = await this.manifestPrototypeGetCourierCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async manifestPrototypeGetCourierCourierSettingRaw(requestParameters: ManifestPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async manifestPrototypeGetCourierCourierSetting(requestParameters: ManifestPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.manifestPrototypeGetCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async manifestPrototypeGetCourierMailOptionRaw(requestParameters: ManifestPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async manifestPrototypeGetCourierMailOption(requestParameters: ManifestPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.manifestPrototypeGetCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierPackages of Manifest.
     */
    async manifestPrototypeGetCourierPackagesRaw(requestParameters: ManifestPrototypeGetCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Queries courierPackages of Manifest.
     */
    async manifestPrototypeGetCourierPackages(requestParameters: ManifestPrototypeGetCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.manifestPrototypeGetCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async manifestPrototypeGetCourierPackagesCourierRaw(requestParameters: ManifestPrototypeGetCourierPackagesCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPackagesCourier().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeGetCourierPackagesCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async manifestPrototypeGetCourierPackagesCourier(requestParameters: ManifestPrototypeGetCourierPackagesCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.manifestPrototypeGetCourierPackagesCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation invoice.
     */
    async manifestPrototypeGetCourierPackagesInvoiceRaw(requestParameters: ManifestPrototypeGetCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPackagesInvoice().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeGetCourierPackagesInvoice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation invoice.
     */
    async manifestPrototypeGetCourierPackagesInvoice(requestParameters: ManifestPrototypeGetCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.manifestPrototypeGetCourierPackagesInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation owner.
     */
    async manifestPrototypeGetCourierPackagesOwnerRaw(requestParameters: ManifestPrototypeGetCourierPackagesOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPackagesOwner().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeGetCourierPackagesOwner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/owner`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation owner.
     */
    async manifestPrototypeGetCourierPackagesOwner(requestParameters: ManifestPrototypeGetCourierPackagesOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.manifestPrototypeGetCourierPackagesOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation storeLocation.
     */
    async manifestPrototypeGetCourierPackagesStoreLocationRaw(requestParameters: ManifestPrototypeGetCourierPackagesStoreLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPackagesStoreLocation().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeGetCourierPackagesStoreLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/storeLocation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation storeLocation.
     */
    async manifestPrototypeGetCourierPackagesStoreLocation(requestParameters: ManifestPrototypeGetCourierPackagesStoreLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.manifestPrototypeGetCourierPackagesStoreLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation plan.
     */
    async manifestPrototypeGetCourierPlanRaw(requestParameters: ManifestPrototypeGetCourierPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Plan>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPlan().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/plan`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation plan.
     */
    async manifestPrototypeGetCourierPlan(requestParameters: ManifestPrototypeGetCourierPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Plan> {
        const response = await this.manifestPrototypeGetCourierPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries pushSubscribers of Courier.
     */
    async manifestPrototypeGetCourierPushSubscribersRaw(requestParameters: ManifestPrototypeGetCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PushSubscription>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PushSubscriptionFromJSON));
    }

    /**
     * Queries pushSubscribers of Courier.
     */
    async manifestPrototypeGetCourierPushSubscribers(requestParameters: ManifestPrototypeGetCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PushSubscription>> {
        const response = await this.manifestPrototypeGetCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async manifestPrototypeGetCourierRewardSettingRaw(requestParameters: ManifestPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async manifestPrototypeGetCourierRewardSetting(requestParameters: ManifestPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.manifestPrototypeGetCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async manifestPrototypeGetCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsAccount>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsAccountFromJSON));
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async manifestPrototypeGetCourierRewardsAccounts(requestParameters: ManifestPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsAccount>> {
        const response = await this.manifestPrototypeGetCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries storeLocations of Courier.
     */
    async manifestPrototypeGetCourierStoreLocationsRaw(requestParameters: ManifestPrototypeGetCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StoreLocation>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StoreLocationFromJSON));
    }

    /**
     * Queries storeLocations of Courier.
     */
    async manifestPrototypeGetCourierStoreLocations(requestParameters: ManifestPrototypeGetCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StoreLocation>> {
        const response = await this.manifestPrototypeGetCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation themeSetting.
     */
    async manifestPrototypeGetCourierThemeSettingRaw(requestParameters: ManifestPrototypeGetCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeGetCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation themeSetting.
     */
    async manifestPrototypeGetCourierThemeSetting(requestParameters: ManifestPrototypeGetCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.manifestPrototypeGetCourierThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async manifestPrototypePatchAttributesRaw(requestParameters: ManifestPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async manifestPrototypePatchAttributes(requestParameters: ManifestPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for couponCodes.
     */
    async manifestPrototypeUpdateByIdCourierCouponCodesRaw(requestParameters: ManifestPrototypeUpdateByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateByIdCourierCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeUpdateByIdCourierCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CouponCodeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for couponCodes.
     */
    async manifestPrototypeUpdateByIdCourierCouponCodes(requestParameters: ManifestPrototypeUpdateByIdCourierCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.manifestPrototypeUpdateByIdCourierCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierBills.
     */
    async manifestPrototypeUpdateByIdCourierCourierBillsRaw(requestParameters: ManifestPrototypeUpdateByIdCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateByIdCourierCourierBills().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeUpdateByIdCourierCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierBills/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierBillToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierBillFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierBills.
     */
    async manifestPrototypeUpdateByIdCourierCourierBills(requestParameters: ManifestPrototypeUpdateByIdCourierCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierBill> {
        const response = await this.manifestPrototypeUpdateByIdCourierCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async manifestPrototypeUpdateByIdCourierPackagesRaw(requestParameters: ManifestPrototypeUpdateByIdCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateByIdCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeUpdateByIdCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async manifestPrototypeUpdateByIdCourierPackages(requestParameters: ManifestPrototypeUpdateByIdCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.manifestPrototypeUpdateByIdCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for pushSubscribers.
     */
    async manifestPrototypeUpdateByIdCourierPushSubscribersRaw(requestParameters: ManifestPrototypeUpdateByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateByIdCourierPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeUpdateByIdCourierPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PushSubscriptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for pushSubscribers.
     */
    async manifestPrototypeUpdateByIdCourierPushSubscribers(requestParameters: ManifestPrototypeUpdateByIdCourierPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.manifestPrototypeUpdateByIdCourierPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async manifestPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters: ManifestPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async manifestPrototypeUpdateByIdCourierRewardsAccounts(requestParameters: ManifestPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.manifestPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for storeLocations.
     */
    async manifestPrototypeUpdateByIdCourierStoreLocationsRaw(requestParameters: ManifestPrototypeUpdateByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateByIdCourierStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling manifestPrototypeUpdateByIdCourierStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for storeLocations.
     */
    async manifestPrototypeUpdateByIdCourierStoreLocations(requestParameters: ManifestPrototypeUpdateByIdCourierStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.manifestPrototypeUpdateByIdCourierStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async manifestPrototypeUpdateCourierCourierSettingRaw(requestParameters: ManifestPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async manifestPrototypeUpdateCourierCourierSetting(requestParameters: ManifestPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.manifestPrototypeUpdateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async manifestPrototypeUpdateCourierMailOptionRaw(requestParameters: ManifestPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async manifestPrototypeUpdateCourierMailOption(requestParameters: ManifestPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.manifestPrototypeUpdateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update invoice of this model.
     */
    async manifestPrototypeUpdateCourierPackagesInvoiceRaw(requestParameters: ManifestPrototypeUpdateCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateCourierPackagesInvoice().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling manifestPrototypeUpdateCourierPackagesInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courierPackages/{nk}/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update invoice of this model.
     */
    async manifestPrototypeUpdateCourierPackagesInvoice(requestParameters: ManifestPrototypeUpdateCourierPackagesInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.manifestPrototypeUpdateCourierPackagesInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardSetting of this model.
     */
    async manifestPrototypeUpdateCourierRewardSettingRaw(requestParameters: ManifestPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Update rewardSetting of this model.
     */
    async manifestPrototypeUpdateCourierRewardSetting(requestParameters: ManifestPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.manifestPrototypeUpdateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update themeSetting of this model.
     */
    async manifestPrototypeUpdateCourierThemeSettingRaw(requestParameters: ManifestPrototypeUpdateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestPrototypeUpdateCourierThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/courier/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Update themeSetting of this model.
     */
    async manifestPrototypeUpdateCourierThemeSetting(requestParameters: ManifestPrototypeUpdateCourierThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.manifestPrototypeUpdateCourierThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async manifestReplaceByIdPostManifestsidReplaceRaw(requestParameters: ManifestReplaceByIdPostManifestsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestReplaceByIdPostManifestsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async manifestReplaceByIdPostManifestsidReplace(requestParameters: ManifestReplaceByIdPostManifestsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestReplaceByIdPostManifestsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async manifestReplaceByIdPutManifestsidRaw(requestParameters: ManifestReplaceByIdPutManifestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling manifestReplaceByIdPutManifestsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async manifestReplaceByIdPutManifestsid(requestParameters: ManifestReplaceByIdPutManifestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestReplaceByIdPutManifestsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async manifestReplaceOrCreatePostManifestsReplaceOrCreateRaw(requestParameters: ManifestReplaceOrCreatePostManifestsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async manifestReplaceOrCreatePostManifestsReplaceOrCreate(requestParameters: ManifestReplaceOrCreatePostManifestsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestReplaceOrCreatePostManifestsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async manifestReplaceOrCreatePutManifestsRaw(requestParameters: ManifestReplaceOrCreatePutManifestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async manifestReplaceOrCreatePutManifests(requestParameters: ManifestReplaceOrCreatePutManifestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestReplaceOrCreatePutManifestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async manifestUpdateAllRaw(requestParameters: ManifestUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async manifestUpdateAll(requestParameters: ManifestUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.manifestUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async manifestUpsertWithWhereRaw(requestParameters: ManifestUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Manifest>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManifestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManifestFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async manifestUpsertWithWhere(requestParameters: ManifestUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Manifest> {
        const response = await this.manifestUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async manifestGetOrphanPackagesRaw(requestParameters: ManifestGetOrphanPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError('courierId', 'Required parameter "courierId" was null or undefined when calling manifestGetOrphanPackages().');
        }

        const queryParameters: any = {};
        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/orphan-packages/${encodeURIComponent(String(requestParameters['courierId']))}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async manifestGetOrphanPackages(requestParameters: ManifestGetOrphanPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ packages: any[]; totalCount: number }> {
        const response = await this.manifestGetOrphanPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async manifestAssignPackagesToManifestRaw(requestParameters: ManifestAssignPackagesToManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError('manifestId', 'Required parameter "manifestId" was null or undefined when calling manifestAssignPackagesToManifest().');
        }
        if (requestParameters['packageIds'] == null) {
            throw new runtime.RequiredError('packageIds', 'Required parameter "packageIds" was null or undefined when calling manifestAssignPackagesToManifest().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/assign-packages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                manifestId: requestParameters['manifestId'],
                packageIds: requestParameters['packageIds'],
            },
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async manifestAssignPackagesToManifest(requestParameters: ManifestAssignPackagesToManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ assigned: number; manifestId: number }> {
        const response = await this.manifestAssignPackagesToManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    // ── Close Manifest ─────────────────────────────────────────────────

    async manifestCloseManifestRaw(requestParameters: ManifestCloseManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError('manifestId', 'Required parameter "manifestId" was null or undefined when calling manifestCloseManifest().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/${encodeURIComponent(String(requestParameters['manifestId']))}/close`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: { manifestId: requestParameters['manifestId'] },
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async manifestCloseManifest(requestParameters: ManifestCloseManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ manifest: Manifest; packageCount: number }> {
        const response = await this.manifestCloseManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    // ── Reopen Manifest ────────────────────────────────────────────────

    async manifestReopenManifestRaw(requestParameters: ManifestReopenManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['manifestId'] == null) {
            throw new runtime.RequiredError('manifestId', 'Required parameter "manifestId" was null or undefined when calling manifestReopenManifest().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/${encodeURIComponent(String(requestParameters['manifestId']))}/reopen`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: { manifestId: requestParameters['manifestId'] },
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async manifestReopenManifest(requestParameters: ManifestReopenManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ manifest: Manifest }> {
        const response = await this.manifestReopenManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    // ── Get Active (Open) Manifest ─────────────────────────────────────

    async manifestGetActiveManifestRaw(requestParameters: ManifestGetActiveManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError('courierId', 'Required parameter "courierId" was null or undefined when calling manifestGetActiveManifest().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Manifests/active-manifest/${encodeURIComponent(String(requestParameters['courierId']))}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async manifestGetActiveManifest(requestParameters: ManifestGetActiveManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ manifest: Manifest; packageCount: number; totalWeight: number } | null> {
        const response = await this.manifestGetActiveManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    // ── Reassign Packages ──────────────────────────────────────────────

    async manifestReassignPackagesRaw(requestParameters: ManifestReassignPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ movedCount: number }>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling manifestReassignPackages().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Manifests/reassignPackages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['data'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<{ movedCount: number }>(response);
    }

    async manifestReassignPackages(requestParameters: ManifestReassignPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ movedCount: number }> {
        const response = await this.manifestReassignPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
